import IsServer from './isServer'

const IsClient = () => !IsServer()

export default IsClient
